import React, { useEffect, useState } from 'react'
import { Doc } from "@/services/model/docs"
import { Translates } from '@/services/repository/i18n'
import { CurrentSession } from '@/services/repository/session'
import { Services } from '@/services/services'
import './docs.css'



export function MachinePopupDocBody({ services, session, translates, machineTypeId }: { translates: Translates, services: Services, machineTypeId: string | undefined, session: CurrentSession | undefined}) {
    const [docs, setDocs] = useState<Doc[]>()
    const [isAlternativeDocs, setAlternativeDocs] = useState<boolean>(false)

    const loadDocForLanguage = (machineTypeId: string, lang: string) => {
        return fetch(`/api/schema/docs/for-machine-type/${machineTypeId}?lang=${lang}`).then((resp) => {
            if (resp.status != 200) {
                return []
            }
            return resp.json().then((data) => {
                return data
            })
        })
    }

    const updateDocs = async (machineTypeId: string | undefined) => {
        if (machineTypeId === undefined) {
            return
        }
        setAlternativeDocs(false)
        try {
            let docs = await loadDocForLanguage(machineTypeId, session ? session.user.lang : services.i18n.defaultLang())
            if (docs?.length !== 0) {
                setDocs(docs)
                return
            }
        } catch (error) {
            console.warn(error)
        }
        let docs = await loadDocForLanguage(machineTypeId, 'en')
        setAlternativeDocs(true)
        setDocs(docs)
    }

    useEffect(() => {
        if(machineTypeId === undefined) {
            return
        }
        updateDocs(machineTypeId)
    }, [machineTypeId])


    const renderDocs = (docs: Doc[]) => {
        const renderRow = (doc: Doc) => <li>
            <a href={doc.url} target='_blank'>
                {doc.name}
            </a>
            <a href={doc.url} download={true} className='downlaod-link'>
                ({translates.for('popup.machine_docs.downlaod_doc')})
            </a>
        </li>
        if (docs.length === 0) {
            return <div className='empty-dock-list'>{translates.for('popup.machine_docs.empty_dock_list')}</div>
        }
        return <ul>{docs.map((doc) => renderRow(doc))}</ul>
    }

    return <div className='docs-popup-body'>
        <h3>{translates.for('popup.machine_docs.documentations_section_title')}</h3>
        {isAlternativeDocs ? translates.for('popup.machine_docs.it_is_alternative_documentation') : null}
        {docs !== undefined ? renderDocs(docs) : null}
    </div>
}